// Generated by scripts/build-ui-icons.mjs.
export { Question as default } from "../ui/glyphs-6";
